const importImage = (imgName, store) => {
    return `${process.env.REACT_APP_BUCKET_BASEURL}/initiatives/${encodeURI(store.loginProjectName)}/myhome/img/${imgName}`;
}

export default importImage;